import React from 'react';
import { Modal } from 'react-bootstrap';

import styles from './ModalForm.module.scss';

interface ModalFormProps {
  show: boolean;
  onHide: () => void;
  title: string;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  children?: React.ReactNode;
  footerButtons?: React.ReactNode[];
}

const ModalForm: React.FC<ModalFormProps> = ({
  show,
  onHide = () => { },
  title,
  onSubmit = (e) => e.preventDefault(),
  children,
  footerButtons = []
}) => {

  return (
    <Modal show={show} onHide={onHide} className={styles['modal-form']} size='lg' centered>
      <form onSubmit={onSubmit}>
        <Modal.Header className={styles['modal-form-header']} closeButton>
          <Modal.Title className={styles.title}>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className={styles['modal-form-body']}>
          {children}
        </Modal.Body>

        <Modal.Footer className={`d-flex gap-2 ${styles['modal-form-footer']}`}>
          {footerButtons.map((btn, idx) => (
            <React.Fragment key={idx}>{btn}</React.Fragment>
          ))}
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ModalForm;
